import {FC, useState} from "react";
import {Event} from "../../../../types/domain.ts";
import {App, Button, Divider, Empty, Flex, Form, FormProps, Image} from "antd";
import styles from './EventBannerContent.module.css';
import {BannerUpload} from "../../../../components/BannerUpload/BannerUpload.tsx";
import {SaveOutlined} from "@ant-design/icons";
import {uploadImage} from "../../../../modules/uploadImage.ts";
import {eventsEventIdPatch} from "../../../../api/events/eventsEventIdPatch.ts";
import {BannerRulesModal} from "../../../../components/BannerRulesModal/BannerRulesModal.tsx";

type Props = {
    event: Event;
    editable: boolean;
    onUpdate: VoidFunction;
}

type FormType = {
    image: { originFileObj: File }[];
}

export const EventBannerContent: FC<Props> = ({ event, editable, onUpdate }) => {
    const { message } = App.useApp();
    const [form] = Form.useForm<FormType>();

    const [loading, setLoading] = useState(false);
    const handleFinish: FormProps<FormType>['onFinish'] = async (values) => {
        setLoading(true);
        const image_id = await uploadImage(values.image);
        return eventsEventIdPatch(event.id, {
            image_id
        }).then(() => {
            void message.success('Сохранено');
            onUpdate();
        }).catch((e) => {
            console.error(e);
            void message.error(`Ошибка (${JSON.stringify(e)})`);
        }).finally(() => setLoading(false));
    }

    return (
        <Flex vertical gap={16} flex="1 0">
            {event.image ? (
                <Image
                    src={event.image ? event.image.url : undefined}
                />
            ) : (
                <Flex align="center" justify="center" className={styles.emptyContainer}>
                    <Empty description="Баннера пока нет!" />
                </Flex>
            )}
            {editable && (
                <>
                    <Divider className={styles.divider} />
                    <Form<FormType>
                        form={form}
                        layout="vertical"
                        onFinish={handleFinish}
                        className={styles.form}
                    >
                        <BannerUpload name="image" required />
                        <Form.Item noStyle>
                            <Button
                                type="primary"
                                className={styles.uploadButton}
                                htmlType="submit"
                                icon={<SaveOutlined />}
                                loading={loading}
                            >Применить</Button>
                        </Form.Item>
                        <BannerRulesModal />
                    </Form>
                </>
            )}
        </Flex>
    )
}